import { applySnapshot, getRoot, types } from 'mobx-state-tree';
import { callAgroApi } from '@services/agroapi';
import { LFDateFormat, isPresent } from '@farmai-shared/LFUtils';
import { CropzoneResponse } from '@services/responseTypes';
import { IRootStoreAny } from './rootUtilType';
import { CropzoneFormData } from '@app/_components/common/CropzoneInputs/utils';
export const CropzoneModal = types.model('CropzoneModal', {
  selectedActivityId: types.maybeNull(types.string)
}).views(self => ({
  get root() {
    return getRoot<IRootStoreAny>(self);
  }
})).actions(self => ({
  setSelectedActivityId(id: string | null) {
    self.selectedActivityId = id;
  },
  reset() {
    applySnapshot(self, {});
  },
  save(data: CropzoneFormData & {
    field_id: string;
  }) {
    const lang = self.root.userStore.user.settings.lang;
    return callAgroApi<CropzoneResponse>(`/organizations/${data.orgId}/cropzones`, 'POST', {
      crop_id: data.crop.value,
      ...(isPresent(data.generation?.value) && {
        generation: data.generation.value
      }),
      ...(isPresent(data.plantingDate) && {
        planting_date: LFDateFormat.datetimeFromInputWithTimezone(data.plantingDate, data.timezone, lang)
      }),
      field_id: data.field_id,
      labels: data.labels?.map(l => ({
        id: l.value
      })),
      ...(isPresent(data.location) && {
        location: data.location
      }),
      ...((isPresent(data.production) || isPresent(data.harvestDate)) && {
        actual: {
          harvest: isPresent(data.production) ? data.production : null,
          harvesting_date: isPresent(data.harvestDate) ? LFDateFormat.datetimeFromInputWithTimezone(data.harvestDate, data.timezone, lang) : null
        }
      })
    });
  }
}));